import BaseClass from "../BaseClass.js";


export default class RemovableListElement extends BaseClass {

    constructor(element) {
        super(element);

        this.url = this.$element.data('url');
        this.$actionElement = null;
        this.clickListener = null;

        let mySelf = this;

        this.clickListener = function () {
            let confirmed = true;
            let $confirmMessage = mySelf.$element.attr('data-confirm');
            if ($confirmMessage) {
                confirmed = confirm($confirmMessage);
            }
            if (confirmed) {
                mySelf.sentRequest();
            }
        };

        this.initActionElement();
    }

    initActionElement() {
        let mySelf = this;
        let $actionElement = this.$element.find('[data-type="actionTrigger"]').first();
        if ($actionElement.length === 1) {
            this.$actionElement = $actionElement;
            $actionElement.on('click', this.clickListener);
        }
    }

    sentRequest() {
        let mySelf = this;
        let jqxhr = $.post(this.url, function () {
        }, 'json').done(function (data) {
            mySelf.$element.remove();
        });
    }

    destroyListener() {
        if (this.$actionElement != null) {
            this.$actionElement.off('click', this.clickListener);
        }
    }
}